import breakpoints from '../../util/css/media';

export default {
    footer: {
        backgroundColor: '#1F1F1F',
        color: 'white',
        paddingTop: 30,
        paddingBottom: 30
    },
    footerHeader: {
        letterSpacing: 2,
        fontWeight: 600,
        marginBottom: 20,

        ['@media (max-width: ' + breakpoints.medium + 'px)']: {
            marginTop: 40 ,
            marginBottom: 5
        }
    },
    footerLink: {
        display: 'block',
        color: 'white',
        textDecoration: 'none',
        cursor: 'pointer',
        marginTop: 5,
        marginBottom: 5
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer/FooterStyle.js